import React from 'react';
import { Banknote, Footprints, MapPin, Truck } from 'lucide-react';

// Each promise mirrors what checkout actually offers (payment method, free-delivery rule, cities list)
const PROMISES = [
  { icon: Banknote, title: 'Paiement à la livraison', text: 'Réglez en toute sérénité à la réception.' },
  { icon: Truck, title: 'Livraison gratuite', text: 'Dès 2 articles commandés.' },
  { icon: Footprints, title: 'Semelles orthopédiques', text: 'Soutien de la voûte plantaire.' },
  { icon: MapPin, title: 'Partout en Tunisie', text: 'Livraison dans les 24 gouvernorats.' },
];

const TrustBar = () => (
  <section aria-label="Nos engagements" className="border-y border-[#0c2a27]/5 bg-white">
    <ul className="mx-auto grid max-w-7xl grid-cols-2 lg:grid-cols-4">
      {PROMISES.map(({ icon: Icon, title, text }, i) => (
        <li
          key={title}
          className={`flex flex-col items-center gap-3 px-4 py-7 text-center sm:flex-row sm:gap-4 sm:px-6 sm:text-left lg:px-8
            ${i % 2 === 1 ? 'border-l border-[#0c2a27]/5' : ''}
            ${i >= 2 ? 'border-t border-[#0c2a27]/5 lg:border-t-0' : ''}
            ${i === 2 ? 'lg:border-l' : ''}`}
        >
          <span className="flex h-12 w-12 flex-none items-center justify-center rounded-full bg-[#f6f1ea] text-[#174540]">
            <Icon className="h-5 w-5" strokeWidth={1.6} />
          </span>
          <span>
            <span className="block text-sm font-semibold text-[#0c2a27]">{title}</span>
            <span className="mt-0.5 block text-xs leading-relaxed text-[#5b6b68]">{text}</span>
          </span>
        </li>
      ))}
    </ul>
  </section>
);

export default TrustBar;
